<template>
  <FormFieldWrapper :data="data">
    <VACheckbox
      :status="modelValue ? 'checked' : 'uncheck'"
      :label="data?.option || 'Option'"
      color="dark-blue"
      @changeStatus="handleStatusChange"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Checkbox',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleStatusChange(status) {
      this.$emit('update:modelValue', status === 'checked');
    }
  }
};
</script>

<style scoped>
</style>
